// Constants that are used in Limits and Usage
import { TableColAlignment } from '@/enums';

export const TABLE_API_STATUS = { recordData: { loading: false, fail: false }, refData: { loading: false, fail: false } };

export const FILTER_HEADINGS = {
  MEMBER: 'Member',
  DATE: 'Date',
  LIMIT: 'Services',
};

export const BLANK_COLUMNS = {
  BLANK_ONE: { display: '', key: 'BLANK_ONE' },
  BLANK_TWO: { display: '', key: 'BLANK_TWO' },
  BLANK_THREE: { display: '', key: 'BLANK_THREE' },
  BLANK_FOUR: { display: '', key: 'BLANK_FOUR' },
};

export const LIMIT_TABLE_COLUMNS = {
  LIMIT: 'Services',
  START_DATE: 'Start date',
  END_DATE: 'End date',
  ANNUAL: 'Limit',
  CONSUMPTION: 'Used',
  REMAINING: 'Remaining',
};

export const EXCESS_TABLE_COLUMNS = {
  EXCESS: 'Excess',
  START_DATE: 'Start date',
  END_DATE: 'End date',
  ANNUAL: 'Amount',
  CONSUMPTION: 'Paid',
  REMAINING: 'Remaining',
};

export const CONSUMPTION_TABLE_COLUMNS = {
  ...BLANK_COLUMNS,
  CONSUMPTION: 'Used',
};

export const SUB_LIMIT_COLUMNS = {
  START_DATE: 'Start date',
  END_DATE: 'End date',
  ANNUAL: 'Limit',
  CONSUMPTION: 'Used',
};

export const REPLACEMENT_COLUMNS = {
  PERIOD: 'Benefit renewed',
};

// Each index represents the table column with the corresponding index
export const TABLE_ALIGNMENTS = [TableColAlignment.LEFT, TableColAlignment.LEFT, TableColAlignment.LEFT, TableColAlignment.RIGHT, TableColAlignment.RIGHT, TableColAlignment.RIGHT];
export const TWO_TABLE_ALIGNMENTS = [TableColAlignment.LEFT, TableColAlignment.RIGHT];

export const FILTER_OPTIONS_INDEX = {
  DATE: 0,
  MEMBER: 1,
  LIMIT: 2,
};

export const DEFAULT_INFORMATION_TEXT = {
  informationText: '',
};

export const TABLE_WIDTHS = [{ width: '30%' }, { width: '15%' }, { width: '15%' }, { width: '13%' }, { width: '13%' }, { width: '13%' }];
export const REPLACEMENT_PERIOD_COLUMN_WIDTHS = [{ width: '45%' }, { width: '30%' }, { width: '25%' }];

export const DEFAULT_LIMIT = 'All service groups';
export const DEFAULT_NO_RECORDS_TEXT = 'No results found.';
export const RETURN_TO_TOP_TEXT = 'Return to top';
